module.exports = "<alert-message *ngIf=\"message\" [translations]=\"messages\" [message]='message'></alert-message>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/reservation-login-required-check/reservation-login-required-check.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/reservation-login-required-check/reservation-login-required-check.component.html
// module chunks = 0